import type { SubmissionController } from '@saas/api-client';

type InboxQuery = NonNullable<Parameters<SubmissionController['inbox']>[0]['query']>;

export type InboxShow = NonNullable<InboxQuery['show']>;

export const INBOX_SHOWS = ['NEW', 'NOT_PREPARED'] as const satisfies readonly InboxShow[];

export const HOME_TABS = ['videos', 'waiting'] as const;

export type HomeTab = (typeof HOME_TABS)[number];

export const DEFAULT_INBOX_PAGE_SIZE = 25;

/** The home's URL state: the inbox's tab and filters, and the search over the Video types beside it. */
export type HomeSearch = {
	tab?: HomeTab;
	q?: string;
	videoTypeId?: string;
	show?: InboxShow;
	page?: number;
	pageSize?: number;
	types?: string;
};
